export const normalizeValue = (value: number | string) => {
  return value.toString().trim().toLowerCase();
};
